import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHelp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.125 10C18.125 5.51269 14.4873 1.875 10 1.875C5.51269 1.875 1.875 5.51269 1.875 10C1.875 14.4873 5.51269 18.125 10 18.125C14.4873 18.125 18.125 14.4873 18.125 10ZM3.125 10C3.125 6.20304 6.20304 3.125 10 3.125C13.797 3.125 16.875 6.20304 16.875 10C16.875 13.797 13.797 16.875 10 16.875C6.20304 16.875 3.125 13.797 3.125 10ZM10 13.125C10.5178 13.125 10.9375 13.5447 10.9375 14.0625C10.9375 14.5803 10.5178 15 10 15C9.48223 15 9.0625 14.5803 9.0625 14.0625C9.0625 13.5447 9.48223 13.125 10 13.125ZM12.8125 8.43785C12.8125 6.88455 11.5533 5.62535 9.99996 5.62535C8.44666 5.62535 7.18746 6.88455 7.18746 8.43785C7.18746 8.78303 7.46728 9.06285 7.81246 9.06285C8.15764 9.06285 8.43746 8.78303 8.43746 8.43785L8.44078 8.33512C8.49369 7.52006 9.17153 6.87535 9.99996 6.87535C10.8629 6.87535 11.5625 7.57491 11.5625 8.43785C11.5625 9.3008 10.8629 10.0004 9.99996 10.0004C9.65478 10.0004 9.37496 10.2802 9.37496 10.6254V11.2504L9.37917 11.3232C9.41527 11.6341 9.67944 11.8754 9.99996 11.8754L10.0728 11.8711C10.3837 11.835 10.625 11.5709 10.625 11.2504L10.6244 11.18L10.7722 11.143C11.95 10.8074 12.8125 9.72334 12.8125 8.43785Z",
		fill: "white"
	})
});
export default SvgHelp;
